module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/promise_05-a1f9b81cc2f45adc40663032af4b6102.png";